import * as Types from './types.generated';

import { api } from 'libs';
module.hot?.accept();
export type SubAreasQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SubAreasQuery = { __typename?: 'Query', subAreas: Array<{ __typename?: 'SubArea', id: string, name: string, createdAt: any }> };

export type CreateSubAreaMutationVariables = Types.Exact<{
  input: Types.CreateSubAreaInput;
}>;


export type CreateSubAreaMutation = { __typename?: 'Mutation', createSubArea?: any };

export type SoftDeleteSubAreaMutationVariables = Types.Exact<{
  softDeleteSubAreaId: Types.Scalars['ID'];
}>;


export type SoftDeleteSubAreaMutation = { __typename?: 'Mutation', softDeleteSubArea?: any };


export const SubAreasDocument = `
    query SubAreas {
  subAreas {
    id
    name
    createdAt
  }
}
    `;
export const CreateSubAreaDocument = `
    mutation CreateSubArea($input: CreateSubAreaInput!) {
  createSubArea(input: $input)
}
    `;
export const SoftDeleteSubAreaDocument = `
    mutation SoftDeleteSubArea($softDeleteSubAreaId: ID!) {
  softDeleteSubArea(id: $softDeleteSubAreaId)
}
    `;

const injectedRtkApi = api.injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (build) => ({
    SubAreas: build.query<SubAreasQuery, SubAreasQueryVariables | void>({
      query: (variables) => ({ document: SubAreasDocument, variables })
    }),
    CreateSubArea: build.mutation<CreateSubAreaMutation, CreateSubAreaMutationVariables>({
      query: (variables) => ({ document: CreateSubAreaDocument, variables })
    }),
    SoftDeleteSubArea: build.mutation<SoftDeleteSubAreaMutation, SoftDeleteSubAreaMutationVariables>({
      query: (variables) => ({ document: SoftDeleteSubAreaDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };


